import AdtInfoListing from "./adtInfoListing.container";

export default AdtInfoListing;
